import { render, staticRenderFns } from "./index.vue?vue&type=template&id=589b9458&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('589b9458')) {
      api.createRecord('589b9458', component.options)
    } else {
      api.reload('589b9458', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=589b9458&", function () {
      api.rerender('589b9458', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/analysis/index.vue"
export default component.exports